import { createStore,applyMiddleware,combineReducers} from "redux";
import {formStateReducer} from '../Reducers/FormStateReducers'
//import { AppReducer } from "../Reducers/AppReducer";

//const rootReducer=combineReducers({data:formStateReducer,AppReducer:AppReducer})
export const formStateStore = createStore(
    formStateReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 }));

/*formStateStore.subscribe(()=>{
    // console.log('subscribe formState :: ',formStateStore.getState());
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
})*/